import { RouterProvider } from 'react-router-dom';
import router from './utils/router';
import { io } from 'socket.io-client';
import '@rainbow-me/rainbowkit/styles.css';
import {
  getDefaultConfig,
  RainbowKitProvider,
} from '@rainbow-me/rainbowkit';
import { WagmiProvider } from 'wagmi';
import { scroll } from 'wagmi/chains';
import {
  QueryClientProvider,
  QueryClient,
} from "@tanstack/react-query";
import { UserProvider } from './context/UserContext';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { Bounce, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Box, Flex, Link } from '@chakra-ui/react';
import TechnicalMaintenance from './pages/maintenance';
const projectId = '6048fad474e21eaf565170493b7233f3'


const config = getDefaultConfig({
  appName: 'ScrollStat',
  projectId: projectId,
  chains: [scroll],
  ssr: true, // If your dApp uses server side rendering (SSR)
});

const queryClient = new QueryClient();
const socket = io('https://socket.scrollstat.xyz', { transports: ['websocket'] });

function App() {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);

  useEffect(() => {
    // Listen for mint events
    socket.on('mintEvent', (eventData) => {
      // console.log('Mint event received:', eventData);
      toast.success(
        <Box maxW="400px" w="100%">
          <Box fontWeight={"bold"}>{`New Key #${eventData.tokenId} Minted! 🚀`}</Box>
          {/* <Text mb={2}>
            {`${eventData.minter.slice(0, 6)}...${eventData.minter.slice(-4)}`} has just minted a new key with ID {eventData.tokenId}.
          </Text> */}
          <Flex flexFlow={"row"} gap={4}>
            <Link isExternal href={`https://scrollscan.com/tx/${eventData.transactionHash}`} rel="noopener noreferrer">View Transaction</Link>
            <Link isExternal href='https://scrollstat.xyz/mint-key'>Mint key</Link>
          </Flex>
        </Box>,
        {
          position: 'top-right',
          autoClose: 12000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          // theme: "colored",
          transition: Bounce
        }
      );
    });

    // Cleanup on component unmount
    return () => {
      socket.disconnect();
    };
  }, []);

  if (isMaintenanceMode) {
    return <TechnicalMaintenance />;
  }


  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>
          <HelmetProvider>
            <UserProvider>
              <RouterProvider router={router} />
              <ToastContainer position="top-right"
                autoClose={9000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ top: '20px', right: '20px' }} // Дополнительное управление стилями
              />
            </UserProvider>
          </HelmetProvider>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;
